/**
 * useSetAppVersion is a hook that sets the app version in the meta tag of the document
 * when Meta tag with name='app-version' has no Content.
 *
 * It also writes the version to the console
 *
 */
import { useEffect } from 'react';

import { useAppVersion } from './useAppVersion';

const useSetAppVersion = () => {
  const appVersion = useAppVersion();

  useEffect(() => {
    if (!appVersion) return;

    // Attempt to get meta element
    const documentAppVersionElement = document?.querySelector?.("meta[name='app-version']");

    if (!documentAppVersionElement) {
      // Create the meta tag if it doesn't exist
      const meta = document.createElement('meta');
      meta.name = 'app-version';
      meta.content = appVersion;
      document.head.appendChild(meta);
      return;
    }
    // Check if the meta tag has content so we don't override it
    const hasContent = documentAppVersionElement?.getAttribute('content');
    if (documentAppVersionElement && !hasContent) {
      documentAppVersionElement.setAttribute('content', appVersion);
    }
    const style =
      'background-color: #0D32AA; color: #ffa064; font-style: italic; font-size: 2em; border: 5px solid #0A2888;';
    //  Write the app version to the console
    console.log(`%cApp version: ${appVersion}`, style);
  }, [appVersion]);

  return {};
};

const AppVersionController = () => {
  useSetAppVersion();
  return null;
};

export { AppVersionController };
